"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateWalletDto = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
class UpdateWalletDto {
    amount;
}
exports.UpdateWalletDto = UpdateWalletDto;
__decorate([
    (0, class_validator_1.IsNotEmpty)({ message: "El monto no puede estar vacío" }),
    (0, class_validator_1.IsNumber)({
        maxDecimalPlaces: 2,
        allowNaN: false,
        allowInfinity: false,
    }, { message: "El monto debe ser un número válido" }),
    (0, class_validator_1.Min)(0, { message: "El monto debe ser un número positivo o cero" }),
    (0, class_transformer_1.Transform)(({ value }) => Number(value)),
    __metadata("design:type", Number)
], UpdateWalletDto.prototype, "amount", void 0);
